module.exports = __webpack_public_path__ + "static/media/proj15_img2.9a95feb3.jpg";